import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = localStorage.getItem('user'); // Obtiene el rol del usuario
    const codRole = user ? JSON.parse(user).cod_role : null;
    if (!codRole) {
      this.router.navigate(['/login']); // Redirige si no hay rol
      return false;
    }

    // Obtiene los roles permitidos de la ruta
    const allowedRoles: string[] = route.data['roles'];

    if (allowedRoles.includes(codRole)) {
      return true; // Acceso permitido
    }

    this.router.navigate(['dashboard/home']); // Redirige si no tiene permiso
    return false;
  }
}
